import { render, staticRenderFns } from "./ChuFangYongYu.vue?vue&type=template&id=15a1193c&scoped=true"
import script from "./ChuFangYongYu.vue?vue&type=script&lang=js"
export * from "./ChuFangYongYu.vue?vue&type=script&lang=js"
import style0 from "./ChuFangYongYu.vue?vue&type=style&index=0&id=15a1193c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a1193c",
  null
  
)

export default component.exports